import instance from '../../api'

export const getCountryList = (search) => instance.get(`/api/admin/countries${search ? `?${search}` : ''}`)

export const updateCountry = (fields) => instance.put(`/api/admin/countries/${fields.id}`, fields)
